<template>
  <div>
    <h2>Данные по транзакции</h2>
    <br>
    <div v-if="item">
      <span>Дата и время: {{ getFormatedDate }}</span>
      <br>
      <span v-if="item.outer_transaction_id">Внешний ID операции: {{ item.outer_transaction_id }}</span>
      <br v-if="item.outer_transaction_id">
      <span>Метод: {{ item.method }}</span>
      <br>
      <span>Платежная система: {{ item.payway }}</span>
      <br>
      <span>Номер карты/кошелька: {{ item.bill }}</span>
      <br>
      <span>Банк: {{ item.bank_name }}</span>
      <br>
      <span>Сумма: {{ item.amount }}</span>
      <br>
      <span>Статус апелляции: {{ getAppealStatus(item.appeal_status) ?? 'Не создана' }}</span>
      <br>
      <br>
    </div>

    <div v-if="isNew">
      <v-select
        v-model="selected"
        :items="options"
        :label="showReason"
        color="accent"
        style="width: 30%"
      />
      <br>

      <v-text-field
        v-if="inputCondition"
        v-model="amount"
        style="width: 30%"
        color="accent"
        label="Введите сумму (без учета комиссии банка)"
      />

      <br>
      <div
        v-if="isNew"
        class="file-upload-container"
        @dragover.prevent
        @drop.prevent="handleDrop"
        @click="selectFile"
      >
        <v-icon small> upload </v-icon>

        <p style="margin-bottom: 0">Выберите файлы</p>

        <p style="margin-bottom: 0">Разрешенные типы файлов: {{ item.appeal_types?.join(', ') }}.</p>

        <p style="margin-bottom: 0">Доступное количество файлов: {{ item.count_appeal_files }}.</p>

        <input
          ref="fileInput"
          type="file"
          class="file-input"
          multiple
          @change="handleFileChange"
        >
      </div>
      <br>

      <div class="file-list">
        <div v-for="(file, index) in selectedFiles" :key="file.id" class="file-item">
          <div class="file-details">
            <span class="file-name">{{ file.name }}</span>
          </div>

          <div class="file-details">
            <span v-if="file.status === 'done'" class="file-status done">Готово</span>

            <span v-else class="file-progress">{{ file.progress }}%</span>

            <button v-if="isNew" style="cursor: pointer" @click="removeFile(index)">
              <v-icon small> close </v-icon>
            </button>
          </div>
        </div>
      </div>
      <br>

      <v-btn
        v-if="isNew"
        text
        color="secondary"
        :disabled="!areAllFilesDone"
        @click="sendAppeal"
      >
        Отправить
      </v-btn>
    </div>

    <template v-if="appeals.length > 0">
      <br>
      <h2>Поданные апелляции</h2>

      <div v-for="(appeal, index) in appeals" :key="index">
        <br>
        <span><b>Апелляция {{ index + 1 }}</b></span>
        <br>
        <span>Дата и время: {{ appeal.created_at }}</span>
        <br>
        <span>Статус: {{ getAppealStatus(appeal.status) }}</span>
        <br>
        <span>Id транзакции платежной системы: {{ appeal.payment_transaction_id }}</span>
        <br>
        <span>Указанная причина: {{ appeal.comment }}</span>
        <br>
        <span v-if="appeal.amount">Сумма апелляции: {{ appeal.amount }}</span>
        <br v-if="appeal.amount">

        <br>
        <div class="file-list">
          <div
            v-for="(file, i) in appeal.files"
            :key="i"
            :style="{ cursor: 'pointer' }"
            class="file-item"
            @click="handleFileClick(file.file_url)"
          >
            <div class="file-details">
              <span class="file-name">{{ file.name }}</span>
            </div>

            <div class="file-status done">Отправлен</div>
          </div>
        </div>
        <br>
        <br>
      </div>
    </template>

    <v-snackbar v-model="snackbar" color="green">
      <p style="margin: 0 auto">Апелляция успешно подана!</p>
    </v-snackbar>
  </div>
</template>

<script>
import { createTransactionAppeal, getTransactionByID } from '../../api/transactions'

export default {
  name: 'UserAppeal',
  data () {
    return {
      item: null,
      isNew: false,
      amount: '',
      snackbar: false,
      selected: '1',
      options: [
        { text: 'Не пришел перевод', value: '1' },
        { text: 'Перевел не ту сумму', value: '2' },
        { text: 'Сделал перевод в несколько чеков', value: '3' },
        { text: 'Перевел не на тот реквизит', value: '4' }
      ],
      selectedFiles: [],
      appeals: []
    }
  },
  computed: {
    showReason () {
      return this.isNew ? 'Укажите причину' : 'Указанная причина'
    },
    inputCondition () {
      return this.selected === '2'
    },
    getFormatedDate () {
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }

      return new Intl.DateTimeFormat('ru-RU', options).format(new Date(this.item.created_at))
    },
    areAllFilesDone () {
      if (this.selected === '2')
        return this.selectedFiles.length > 0 && this.selectedFiles.every(file => file.status === 'done') && this.amount && this.amount !== '0'
      return this.selectedFiles.length > 0 && this.selectedFiles.every(file => file.status === 'done')
    }
  },
  async created () {
    const res = await getTransactionByID(this.$route.params.user)
    this.item = res.data
    if (this.item.appeals)
      this.appeals = this.item.appeals
    this.isNew = this.$route.query.new
  },
  mounted () {
    document.addEventListener('paste', this.handlePaste)
  },
  beforeDestroy () {
    document.removeEventListener('paste', this.handlePaste)
  },
  methods: {
    handlePaste (event) {
      const clipboardItems = event.clipboardData.items
      for (let i = 0; i < clipboardItems.length; i++) {
        const item = clipboardItems[i]
        if (item.kind === 'file') {
          const file = item.getAsFile()
          if (file)
            this.processFiles([file])
        }
      }
    },
    handleFileClick (link) {
      if (link)
        window.open(link, '_blank')
    },
    getAppealStatus (status) {
      if (status === 1)
        return 'Отклонено'
      if (status === 2)
        return 'успешно'
      if (status === 3)
        return 'Ошибка'
      if (status === 4)
        return 'Отправлен'
    },
    selectFile () {
      const fileInput = this.$refs.fileInput
      if (fileInput)
        fileInput.click()
    },
    handleDrop (event) {
      if (event.dataTransfer) {
        const files = event.dataTransfer.files
        this.processFiles(files)
      }
    },
    handleFileChange (event) {
      const target = event.target
      if (target.files)
        this.processFiles(target.files)

    },
    processFiles (fileList) {
      const filesArray = Array.from(fileList)

      if (this.selectedFiles.length + filesArray.length > this.item.count_appeal_files) {
        alert(`Можно загрузить не более ${this.item.count_appeal_files} файлов.`)
        return
      }

      filesArray.forEach((file, index) => {
        const fileSizeInMB = file.size / (1024 * 1024)
        if (fileSizeInMB > 5) {
          alert(`Файл "${file.name}" превышает лимит в 5 МБ.`)
          return
        }

        const fileExtension = file.name.split('.').pop()
          .toLowerCase()
        if (this.item.appeal_types && !this.item.appeal_types.includes(fileExtension)) {
          alert(`Файл "${file.name}" имеет не верное расширение.`)
          return
        }

        const fileData = {
          id: Date.now() + index,
          file,
          name: file.name,
          progress: 0,
          status: 'uploading'
        }
        this.selectedFiles.push(fileData)
        this.simulateUpload(fileData)
      })
    },
    simulateUpload (file) {
      const progressStep = Math.floor(Math.random() * 20) + 10
      const intervalTime = Math.floor(Math.random() * 200) + 100

      const interval = setInterval(() => {
        if (file.progress < 100) {
          file.progress += progressStep
          if (file.progress > 100) file.progress = 100
        } else {
          file.status = 'done'
          clearInterval(interval)
        }
      }, intervalTime)
    },
    removeFile (index) {
      this.selectedFiles.splice(index, 1)
    },
    async sendAppeal () {
      const formData = new FormData()
      if (this.amount)
        formData.append('amount', this.amount)
      if (this.selected) {
        const option = this.options.find(option => option.value === this.selected)
        formData.append('comment', option.text)
      }
      this.selectedFiles.forEach(fileData => {
        formData.append('attachment[]', fileData.file, fileData.name)
      })
      try {
        await createTransactionAppeal(this.item.id, formData)
        this.snackbar = true
        this.isNew = false
      } catch (error) {
        alert(error.response.data.message)
      }
    }
  }
}
</script>

<style scoped>
.file-upload-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: 2px dashed #ccc;
  border-radius: 36px;
  width: 30%;
  height: 100%;
  padding: 55px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: #666;
  }

  .file-input {
    display: none;
  }
}

.file-list {
  display: flex;
  width: 35%;
  flex-direction: column;
  gap: 4px;

  & span {
    margin: 0;
  }
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-radius: 36px;
  background: #e0e0e0ff;
}

.file-details {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 500px;

  @media (max-width: 999px) {
    max-width: 180px;
  }
}

.file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
}

.file-progress {
  color: orange;
}

.file-status.done {
  color: #13ab75;
  font-weight: bold;
}
</style>
